import { useAppSelector } from "../../store/storeHooks"
import { selectEffectiveCompanyId, selectEffectiveUserType } from "../../context/contextSelectors"
import { UserType } from "../../login/loginTypes"

export function useCurrentServiceCenter() {
    const userType = useAppSelector(selectEffectiveUserType)
    const companyId = useAppSelector(selectEffectiveCompanyId)

    if (userType !== UserType.SERVICE_CENTER) {
        throw new Error("Invalid state: not currently acting as a service center")
    }
    if (!companyId) {
        throw new Error("Invalid state: effective service center id not found")
    }

    return {
        serviceCenterId: companyId
    }
}
